//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import interceptBackButton from "../intercept-back-button.js";
import SquareButton from "./square-button.vue";
import DateMenuContent from "./date-menu-content.vue";
import { isSubtask, fromMatchingDb, colorArray, labelColorArray } from "../utils.js";
import { createLabel } from "../item.js";
import {
  addTaskRepeat,
  clearColor,
  setTaskColor,
  archiveItems,
  unarchiveItems,
  duplicateItem,
  deleteItem,
  foldTask,
  changeType,
  convertItemToList,
} from "../db-utils.js";
import { bulkNestAtEnd, bulkCategoryAtEnd, bulkStatusAtEnd, removeStatus, removeCategory } from "../ordered-relation.js";
import { exportToCalendar } from "../gcalendar-utils.js";

export default {
  props: {
    item: Object,
    elems: {
      type: Array,
      required: false,
    },
  },
  components: {
    SquareButton,
    DateMenuContent,
  },
  data() {
    return {
      menuOpen: false,
      membersMenu: false,
      dateMenu: false,
      listMenu: false,
      statusMenu: false,
      categoryMenu: false,
      labelMenu: false,
      colorMenu: false,
      labelColorMenu: false,
      chosenLabel: null,
      typeMenu: false,
      deleteDialog: false,
      colorArray: colorArray,
      labelColorArray: labelColorArray,
      backdropEl: null,
      clearBackButtonHandler: null,
      members: this.item.couch.collaborators,
      icons: {
        note: "notes",
        task: "check_box",
        goal: "flag",
        separator: "space_bar",
      },
      isMobile: "ontouchstart" in window || window.navigator.msMaxTouchPoints > 0,
    };
  },
  computed: {
    taskView() {
      return this.$route.params.taskId === this.item._id;
    },
    listConversion() {
      return this.$settings && this.$settings.listConversion === true;
    },
    multilist() {
      return this.$settings && this.$settings.multilist !== false;
    },
    categories() {
      return this.$settings && this.$settings.categories === true;
    },
    statuses() {
      return this.$settings && this.$settings.statuses === true;
    },
    selectionMode() {
      return !!this.$taskCardsController.selectedTasksIds;
    },
    concealedIcon() {
      return !!this.item.concealName ? "visibility" : "visibility_off";
    },
    concealedText() {
      return !!this.item.concealName
        ? this.$gettext("Reveal name")
        : this.$gettext("Conceal name");
    },
    cannotExportToGcal() {
      return (
        !this.item.plannedFor ||
        this.item.plannedFor.parentClass !== "day" ||
        !!this.item.gcal_id ||
        this.item.type === "event"
      );
    },
    foldableCount() {
      if (!this.elems) return 0;
      let count = 0;
      for (const el of this.elems) {
        const subelements = el.getChildren();
        if (subelements.length > 2) {
          ++count;
        }
      }
      return count;
    },
    foldedCount() {
      let count = 0;
      for (const el of this.elems) {
        if (el.localFolded) {
          ++count;
        }
      }
      return count;
    },
    everythingSelected() {
      if (
        !this.elems ||
        !this.elems.length ||
        !this.$taskCardsController ||
        !this.$taskCardsController.selectedTasksIds
      ) {
        return false;
      }
      let count = 0;
      for (const el of this.elems) {
        if (this.$taskCardsController.selectedTasksIds[el._id]) {
          ++count;
        }
      }
      return !!count;
    },
  },
  methods: {
    itemTypeName(type) {
      switch (type) {
        case "task":
          return this.$gettext("task");
        case "note":
          return this.$gettext("note");
        case "goal":
          return this.$gettext("goal");
        case "separator":
          return this.$gettext("separator");
      }
    },
    conversionText(type) {
      switch (type) {
        case "task":
          return this.$gettext("Convert to a task");
        case "note":
          return this.$gettext("Convert to a note");
        case "goal":
          return this.$gettext("Convert to a goal");
        case "separator":
          return this.$gettext("Convert to a separator");
      }
    },
    isSubtask,
    changeType,
    fromMatchingDb,
    addRepeat() {
      addTaskRepeat(this.item);
    },
    openInTaskView() {
      this.$router.push(`/task/${this.item._id}`);
    },
    changeOwner() {
      this.$root.$emit("share-dialog", {
        item: this.item,
        dbs: this.$sessionState.dbs,
      });
    },
    changeColor(color) {
      if (color === "undefined") {
        clearColor(this.item);
      } else {
        setTaskColor(this.item, color);
      }
      this.colorMenu = false;
    },
    changeLabelColor(color) {
      if (color === "undefined") {
        clearColor(this.chosenLabel);
      } else {
        setTaskColor(this.chosenLabel, color);
      }
      this.labelColorMenu = false;
    },
    canConvertTo(type) {
      if (this.item.type === type) return false;
      if (type === "separator") {
        return this.item.getChildren().length === 0;
      }
      return true;
    },
    convertToList() {
      const newId = convertItemToList(this.item);
      this.$router.push('/lists/' + newId);
    },
    changeStatus(listID) {
      bulkStatusAtEnd({
        reactiveCache: this.$reactiveCache,
        tasks: [this.item],
        newPPtr: { parentClass: "list", parentKey: listID },
      });
    },
    moveToList(listID) {
      bulkNestAtEnd({
        reactiveCache: this.$reactiveCache,
        tasks: [this.item],
        newPPtr: { parentClass: "list", parentKey: listID },
      });
    },
    moveToCategory(listID) {
      bulkCategoryAtEnd({
        reactiveCache: this.$reactiveCache,
        tasks: [this.item],
        newPPtr: { parentClass: "list", parentKey: listID },
      });
    },
    clearStatus() {
      removeStatus(this.item)
    },
    clearCategory() {
      removeCategory(this.item)
    },
    createLabel() {
      const name = prompt(this.$gettext("Label name:"), "");
      if (name) {
        const id = createLabel(name, this.$reactiveCache, this.item.couch);
        this.toggleLabel(id);
      }
    },
    labelIcon(labelId) {
      return this.item.labels?.includes(labelId)
        ? "check_box"
        : "check_box_outline_blank";
    },
    toggleLabel(labelId) {
      if (!this.item.labels) {
        this.item.labels = [labelId];
      } else if (this.item.labels.includes(labelId)) {
        let idx = this.item.labels.indexOf(labelId);
        this.item.labels.splice(idx, 1);
      } else {
        this.item.labels.push(labelId);
      }
      this.item.save();
    },
    memberIcon(id) {
      return this.item.assignees?.includes(id)
        ? "check_box"
        : "check_box_outline_blank";
    },
    toggleMember(id) {
      if (!this.item.assignees) {
        this.item.assignees = [id];
      } else if (this.item.assignees.includes(id)) {
        let idx = this.item.assignees.indexOf(id);
        this.item.assignees.splice(idx, 1);
      } else {
        this.item.assignees.push(id);
      }
      this.item.save();
    },
    toggleConcealed() {
      this.item.concealName = !this.item.concealName;
      this.item.save();
    },
    exportToCalendar() {
      exportToCalendar(this.item);
      this.$root.$emit('snackbar', {msg: "Item exported to Google Calendar"});
    },
    cut() {
      this.$taskCardsController.startAttaching(this.item);
    },
    duplicate() {
      duplicateItem(this.$reactiveCache, this.item);
    },
    archive() {
      archiveItems([this.item], this);
    },
    unarchive() {
      unarchiveItems([this.item]);
    },
    remove() {
      this.deleteDialog = false;
      // TODO: Wait for the result?
      deleteItem(this.item, this.$reactiveCache);
    },
    foldAll() {
      for (const el of this.elems) {
        foldTask(el);
      }
    },
    unfoldAll() {
      for (const el of this.elems) {
        unfoldTask(el);
      }
    },
    select() {
      this.$taskCardsController.select(this.item);
    },
    selectAll() {
      for (const el of this.elems) {
        this.$taskCardsController.select(el);
      }
    },
    unselectAll() {
      for (const el of this.elems) {
        this.$taskCardsController.unselect(el);
      }
    },
    // handle operations that should exit the menu.
    onOpened() {
      this.showBackdrop();
      this.clearBackButtonHandler = interceptBackButton(() => {
        this.menuOpen = false;
        this.membersMenu = false;
        this.dateMenu = false;
        this.listMenu = false;
        this.statusMenu = false;
        this.categoryMenu = false;
        this.labelMenu = false;
        this.colorMenu = false;
        this.labelColorMenu = false;
        this.typeMenu = false;
        this.deleteDialog = false;
      });
    },
    onClosed() {
      if (
        this.membersMenu ||
        this.dateMenu ||
        this.listMenu ||
        this.statusMenu ||
        this.categoryMenu ||
        this.labelMenu ||
        this.colorMenu ||
        this.labelColorMenu ||
        this.typeMenu
      ) {
        return;
      }
      if (this.clearBackButtonHandler) {
        this.clearBackButtonHandler();
        this.clearBackButtonHandler = null;
      }
      this.removeBackdrop();
    },
    showBackdrop() {
      if (!this.backdropEl) {
        this.backdropEl = document.createElement("div");
        this.backdropEl.classList.add("task-card-menu-backdrop");
        document.body.appendChild(this.backdropEl);
      }
    },
    removeBackdrop() {
      if (this.backdropEl) {
        this.backdropEl.remove();
        this.backdropEl = null;
      }
    },
  },
  beforeDestroy() {
    this.onClosed();
  },
};
